import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthentication } from '../auth';
import { NotFound } from '../NotFound';
import { hasAdminAccess } from '../util/auth';
import { Admin as AdminView } from './views/Admin';

export const Admin = () => {
  const currentUser = useAuthentication();

  if (!hasAdminAccess(currentUser)) {
    return <NotFound />;
  }

  return (
    <Routes>
      <Route index element={<Navigate to="/admin/users" replace={true} state={{ resetView: true }} />} />
      <Route path="/users" element={<AdminView />} />
      <Route path="/clinics" element={<AdminView />} />
      <Route path="/lifeglov-liner-stock" element={<AdminView />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
